/**
 * CapitalTile - Tile design for Capital section
 *
 * Uses BaseTile with full-bleed background image design.
 * Focus: Funding details and investment parameters
 */
import React from 'react';
import BaseTile from './BaseTile';

function CapitalTile({
  resource,
  sectionColor,
  onClick,
  adminMode,
  onRemove,
  onMoveLeft,
  onMoveRight,
  isFirst,
  isLast,
}) {
  return (
    <BaseTile
      resource={resource}
      sectionColor={sectionColor}
      onClick={onClick}
      adminMode={adminMode}
      onRemove={onRemove}
      onMoveLeft={onMoveLeft}
      onMoveRight={onMoveRight}
      isFirst={isFirst}
      isLast={isLast}
    />
  );
}

export default CapitalTile;
